import axios from "src/lib/axios";

export const getWebMethodsList = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/WebMethod/GetWebMethodsList'
    );
    return response?.data;
  };
  
  export const getWebMethodsByKey = async (webMethodKey): Promise<any> => {
    const response = await axios.get<any>(
      `/WebMethod/GetWebMethods?webMethodKey=${webMethodKey}`
    );
    return response?.data || {};
  };
  
  export const insertUpdateWebMethods = async (
    data: any
  ): Promise<any> => {
    const response = await axios.post<any>(
      `/WebMethod/InsertUpdateWebMethods`,
      data
    );
    return response.data;
  };
  
  export const deleteWebMethods = async (webMethodKey): Promise<any> => {
    const response = await axios.post<any>(
      `WebMethod/DeleteWebMethod/${webMethodKey}`
    );
    return response?.data;
  };
  
  export const getWebMethodVerbMaster = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/WebMethod/GetWebMethodVerbMaster'
    );
    return response?.data;
  };
  
  export const getContentTypeMaster = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/WebMethod/GetContentTypeMaster'
    );
    return response?.data;
  };
  
  export const getRequestBodyDataTypeMaster = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/WebMethod/GetRequestBodyDataTypeMaster'
    );
    return response?.data;
  };
  
  export const getWebMethodAuthTypeMaster = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/WebMethod/GetWebMethodAuthTypeMaster'
    );
    return response?.data;
  };
  
  export const getFieldDataTypeMaster = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/WebMethod/GetFieldDataTypeMaster'
    );
    return response?.data;
  };
  
  export const getFieldDataTypeFormatMaster = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/WebMethod/GetFieldDataTypeFormatMaster'
    );
    return response?.data;
  };
  
  export const executeWebMethod = async (
    data: any
  ): Promise<any> => {
    const response = await axios.post<any>(
      `/WebMethod/ExecuteWebMethod`,
      data
    );
    return response.data;
  };
  
  export const GetWebMethodForDropDown = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/WebMethod/GetWebMethodForDropDown'
    );
    return response?.data;
  };